export const TOKENS_PER_STAR = 1000000000000000000
